<template>
  <b-modal
    id="modal-await-confirm-email"
    hide-footer
    centered
    :noCloseOnBackdrop="false"
    :noCloseOnEsc="false"
    :hideHeaderClose="false"
  >
    <div
      class="col-12 d-flex flex-column align-items-center modalsTables"
      style="position: relative; z-index: 1"
    >
      <h3 class="mb-5"><strong>Hola, estamos esperando confirmación por parte del paciente.</strong></h3>

      <b-alert show variant="info" class="alert-info-message">
        <div class="d-flex">
          <div class="mr-3">
            <img src="@/assets/images/icons/icon-morbidity/icon1.png" alt="" />
          </div>
          <p style="font-size: 14px; color: #004bd1; margin-bottom: 0">
            En caso de que no recibas el correo confirmando, dale click en el
            botón “enviar nueva confirmación”.
          </p>
        </div>
      </b-alert>

      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button-primary"
          style="color: white !important"
          @click.prevent="handleClick()"
        >
          Enviar nueva confirmación
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick() {
      const me = this;
      me.$bvModal.hide('modal-await-confirm-email');
      me.$bvModal.show('modal-request-confirm-email');
    },
  },
};
</script>
